import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { timeZoneSelector } from 'Features/App/appSlice';
import { commonWidgetInfo, sourceIdSetter } from 'Features/StationsNew/Datasources/Datasource/Monitors/utils';
import { WindRoseChart } from './SimpleWidgets/WindRose';
import { PartWidgetData, WidgetData } from '../types';

type WindRoseChartWrapperProps = {
  windRoseChartWidgetData: PartWidgetData[]
  windRoseWidgetArrowWidgetData: WidgetData
}

export function WindRoseChartWrapper({
  windRoseChartWidgetData,
  windRoseWidgetArrowWidgetData,
}: WindRoseChartWrapperProps) {
  const { datasourceId } = useParams();
  const zones = useSelector(timeZoneSelector, (a, b) => a.selectedUserTimeZone === b.selectedUserTimeZone);

  const options = React.useMemo(() => {
    const commonDataInfo = commonWidgetInfo(zones.selectedUserTimeZone);
    return {
      commonDataInfo: {
        ...commonDataInfo,
        requestSeriesItems: windRoseChartWidgetData.map(sourceIdSetter(+datasourceId)),
      },
      arrowDataInfo: {
        ...commonDataInfo,
        requestItems: windRoseWidgetArrowWidgetData.map(sourceIdSetter(+datasourceId)),
      },
    };
  }, [datasourceId, windRoseChartWidgetData, windRoseWidgetArrowWidgetData, zones.selectedUserTimeZone]);

  return (
    <WindRoseChart options={options} />
  );
}
